import { Radio } from '@mui/material';
import { ChangeEvent, PropsWithChildren, ReactNode } from 'react';
import TypeChip from './TypeChip';

interface IProps extends PropsWithChildren {
  label: string;
  labelIcon?: ReactNode;
  printPdfMode?: boolean;
  checkedForPrint?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  value: string;
  disabled?: boolean;
}

const ImpressionFilterRadioButton = ({
  label,
  labelIcon,
  printPdfMode,
  checkedForPrint,
  onChange,
  value,
  ...props
}: IProps) => {
  return (
    <Radio
      sx={{ padding: 0 }}
      disableRipple
      checkedIcon={
        <TypeChip
          label={label}
          labelIcon={labelIcon}
          printPdfMode={printPdfMode}
          checkedForPrint={checkedForPrint}
          onChange={onChange}
          value={value}
          checked
        />
      }
      icon={
        <TypeChip
          label={label}
          labelIcon={labelIcon}
          printPdfMode={printPdfMode}
          checkedForPrint={checkedForPrint}
          onChange={onChange}
          value={value}
        />
      }
      slotProps={{ input: { 'aria-label': label } }}
      value={value}
      {...props}
    />
  );
};

export default ImpressionFilterRadioButton;
